'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroBannerWrapper = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = require('react-redux');

var _heroBanner = require('../../redux/selectors/heroBanner');

var selectors = _interopRequireWildcard(_heroBanner);

var _FullWidthBackground = require('acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground');

var _Link = require('acq-components/lib/base-components/Link/Link');

var _Typography = require('acq-components/lib/base-components/Typography/Typography');

var _HeroBanner = require('acq-components/lib/composite-components/HeroBanner/HeroBanner');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroBannerWrapper = function HeroBannerWrapper(_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      namespace = _ref.namespace,
      dtmHelper = _ref.dtmHelper,
      isCompare = _ref.isCompare,
      props = (0, _objectWithoutProperties3.default)(_ref, ['styles', 'namespace', 'dtmHelper', 'isCompare']);
  return _react2.default.createElement(
    _FullWidthBackground.FullWidthBackground,
    {
      styles: styles.fullWidthBackground,
      isImageRepeated: true,
      backgroundImgUrl: props.background.url,
      custClassName: 'hero-banner'
    },
    _react2.default.createElement(_HeroBanner.HeroBanner, {
      styles: styles.heroBanner,
      PrimaryContentComponent: _Typography.Typography,
      primaryContentProps: {
        components: {
          title: props.header,
          description: props.description || []
        },
        componentProps: {
          title: {
            isHeader: true
          }
        },
        ChildComponent: function ChildComponent(_ref2) {
          var isHeader = _ref2.isHeader,
              props = (0, _objectWithoutProperties3.default)(_ref2, ['isHeader']);

          var Tag = isHeader ? isCompare ? 'h1' : 'h2' : 'p';
          return _react2.default.createElement(
            Tag,
            (0, _extends3.default)({}, props, { style: { fontWeight: 400 } }),
            props.children
          );
        },
        styles: styles.heroBanner
      },
      SecondaryContentComponent: function SecondaryContentComponent() {
        return null;
      },
      TertiaryContentComponent: 'div',
      tertiaryContentProps: {
        className: styles.heroBanner.languageToggle,
        children: props.languageToggleButton && props.languageToggleButton.title && _react2.default.createElement(
          _Link.Link,
          {
            to: dtmHelper && dtmHelper.getUrlByLinkObj((0, _lodash2.default)(props, 'languageToggleButton'), _dtmConsts.DTM_CONSTS.hero),
            className: styles.heroBanner.languageToggleButton,
            namespace: namespace,
            qeId: 'Hero-languageToggle',
            title: props.languageToggleButton.hoverText
          },
          props.languageToggleButton.title
        )
      },
      namespace: namespace,
      qeId: props.qeId
    })
  );
};

exports.HeroBannerWrapper = HeroBannerWrapper;
var mapStateToProps = function mapStateToProps(state) {
  return {
    background: selectors.getBackground(state),
    description: selectors.getDescription(state),
    header: selectors.getHeader(state),
    languageToggleButton: selectors.getToggleButton(state),
    qeId: selectors.getHeroQeId(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HeroBannerWrapper);